export default __webpack_public_path__ + "static/media/backpack.e8beddb7.png";